import React from 'react';

interface QuizSubmittedScoreProps {
  score: number;
  submittedAt?: string | null;
  passDegree?: number | null;
  onContinue?: () => void;
  continueLabel?: string;
}

export const QuizSubmittedScore: React.FC<QuizSubmittedScoreProps> = ({
  score,
  submittedAt,
  passDegree,
  onContinue,
  continueLabel = 'متابعة',
}) => {
  const roundedScore = Math.round(score);
  const passed =
    passDegree != null && Number.isFinite(passDegree) ? roundedScore >= passDegree : null;

  return (
    <div className="quiz-submitted-score text-center" dir="rtl">
      <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-2">تم تسليم الاختبار</h3>
      <p className="text-gray-600 mb-6">لقد أكملت هذا الاختبار مسبقاً.</p>

      <div className="bg-gray-50 rounded-xl p-6 max-w-sm mx-auto mb-6">
        <p className="text-sm text-gray-500 mb-1">درجتك</p>
        <div className="text-4xl font-bold text-primary mb-2">{roundedScore}%</div>
        {passed !== null && (
          <p className={`text-sm font-medium ${passed ? 'text-green-700' : 'text-amber-700'}`}>
            {passed ? 'ناجح' : 'لم تحقق درجة النجاح'}
            {passDegree != null ? ` (الحد الأدنى ${passDegree}%)` : ''}
          </p>
        )}
        <div className="w-full bg-gray-200 rounded-full h-2.5 mt-4">
          <div
            className="bg-primary h-2.5 rounded-full transition-all duration-1000"
            style={{ width: `${Math.min(100, Math.max(0, roundedScore))}%` }}
          />
        </div>
        {submittedAt && (
          <p className="text-xs text-gray-500 mt-4">
            تاريخ التسليم:{' '}
            {new Date(submittedAt).toLocaleDateString('ar-EG', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </p>
        )}
      </div>

      {onContinue && (
        <button
          type="button"
          onClick={onContinue}
          className="px-6 py-3 rounded-lg font-medium bg-primary text-white hover:bg-primary/90 transition-colors"
        >
          {continueLabel}
        </button>
      )}
    </div>
  );
};
